import { render, staticRenderFns } from "./RegularMessage.vue?vue&type=template&id=40940010&"
import script from "./RegularMessage.vue?vue&type=script&lang=js&"
export * from "./RegularMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40940010')) {
      api.createRecord('40940010', component.options)
    } else {
      api.reload('40940010', component.options)
    }
    module.hot.accept("./RegularMessage.vue?vue&type=template&id=40940010&", function () {
      api.rerender('40940010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/RegularMessage.vue"
export default component.exports